/** Czech fallback labels for officer role codes (used when the API sends no `roleLabel`). */
export const ROLE_LABELS: Record<string, string> = {
	STATUTORY_DIRECTOR: "Jednatel",
	BOARD_MEMBER: "Člen představenstva",
	BOARD_CHAIR: "Předseda představenstva",
	SUPERVISORY_BOARD_MEMBER: "Člen dozorčí rady",
	SUPERVISORY_BOARD_CHAIR: "Předseda dozorčí rady",
	PROXY: "Prokurista",
	LIQUIDATOR: "Likvidátor",
	MANAGING_DIRECTOR: "Ředitel",
};
